import { Button, Card, Container, Dimmer, Form, Header, Icon, Loader, Menu, Modal, Segment, Table, TableCell, Dropdown, Label, Message } from "semantic-ui-react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import MenuSistema from "../components/menu_sistema";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import { useEffect, useRef, useState } from "react";
import { pdf } from "@react-pdf/renderer";
import RelatorioPdfConsulta from "./relatorio_pdf_consulta";
import axios from "axios";
import {
  URL_AGENCIADOR,
  URL_APROVADO_POR,
  URL_COMISSOES,
  URL_CONSULTAR_LOTE,
  URL_CONSULTAR_STATUS_APRO,
  URL_CONSULTAR_STATUS_PGCOM,
  URL_DADOS_VENDA,
  URL_DADOS_VENDA_LOTE,
  URL_FILIAL,
  URL_LANCAMENTO,
  URL_OBTER_RELACIONAMENTO,
  URL_OBTER_RELACIONAMENTO_EMLOTE,
  URL_RCA,
  URL_STATUS_FATURA,
  URL_STATUS_PENDENTE,
  URL_USUARIO,
} from "../main/api_calls";

import Util from "../main/util";
import AuthenticationService from "../main/AuthenticationService";
import { useNavigate } from "react-router-dom";
import { CHAVE_WINTHOR_SERVICE } from "../constantes";

const selectPgCom = [
  { key: "1", value: "", text: "Selecione" },
  { key: "2", value: "Em Aberto", text: "Em Aberto" },
  { key: "3", value: "Pago", text: "Pago" },
  { key: "4", value: "Parcialmente Pago", text: "Parcialmente Pago" },
  { key: "5", value: "Em Aberto+Parcialmente Pago", text: "Em Aberto (inclui Parc. Pago)" },
];
const selectStatusApro = [
  { key: "1", value: "", text: "Selecione" },
  { key: "2", value: "Aprovada", text: "Aprovada" },
  { key: "3", value: "Pendente", text: "Pendente" },
  { key: "4", value: "Rejeitada", text: "Rejeitada" },
];

const STATUS_APROVACAO = {
  APROVADA: "Aprovada",
  PENDENTE: "Pendente",
  REJEITADA: "Rejeitada",
};

const STATUS_PG_COM_ABERTO_COM_PARCIAL = "Em Aberto+Parcialmente Pago";
const LIMITE_CONFIRMACAO_CONSULTA = 200;

export default function HistoricoVendas() {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState({});

  const [menuFiltro, setMenuFiltro] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [faturaModal, setFaturaModal] = useState(null);
  const [openModalExcel, setOpenModalExcel] = useState(false);
  const [openModalPdf, setOpenModalPdf] = useState(false);

  // Status de fatura para exportação Excel (Quitada = "Paga" no negócio)
  const [excelStatusFatura, setExcelStatusFatura] = useState({
    Quitada: true,
    "A Vencer": true,
    Vencida: true,
  });
  // Status de comissão/aprovação para exportação Excel
  const [excelStatusComissao, setExcelStatusComissao] = useState({
    Pendente: true,
    "Em Aberto": true,
    "Parcialmente Pago": true,
    Aprovada: true,
    Rejeitada: true,
    Pago: false,   // desmarcado por padrão
  });

  // Status de fatura para PDF
  const [pdfStatusFatura, setPdfStatusFatura] = useState({
    Quitada: true,
    "A Vencer": true,
    Vencida: true,
  });
  // Status de comissão/aprovação para PDF (todos habilitados por padrão)
  const [pdfStatusComissao, setPdfStatusComissao] = useState({
    Pendente: true,
    "Em Aberto": true,
    "Parcialmente Pago": true,
    Aprovada: true,
    Rejeitada: true,
    Pago: false,   // desmarcado por padrão (igual ao Excel)
  });

  const [listaFaturas, setListaFaturas] = useState([]);
  const [listaFaturasIncluindoNegativas, setListaFaturasIncluindoNegativas] = useState([]);
  const [listaFiliais, setListaFiliais] = useState([]);
  const [listaAgenciadores, setListaAgenciadores] = useState([]);
  const [listaRCA, setListaRCA] = useState([]);
  const [listaStatusFatura, setListaStatusFatura] = useState([]);
  const [listaAprovadores, setListaAprovadores] = useState([]);

  const [filtroFilial, setFiltroFilial] = useState([]);
  const [filtroRca, setFiltroRca] = useState([]);
  const [filtroAgenciador, setFiltroAgenciador] = useState([]);
  const [filtroNota, setFiltroNota] = useState("");
  const [filtroTransacao, setFiltroTransacao] = useState("");
  const [checkPaga, setCheckPaga] = useState(true);
  const [checkAVencer, setCheckAVencer] = useState(true);
  const [checkVencida, setCheckVencida] = useState(true);
  const [ocultarComissoesNegativas, setOcultarComissoesNegativas] = useState(true);
  const [collapseQuitadas, setCollapseQuitadas] = useState(false);
  const [collapseAVencer, setCollapseAVencer] = useState(false);
  const [collapseVencidas, setCollapseVencidas] = useState(false);
  const [filtroPgCom, setFiltroPgCom] = useState("");
  const [filtroEmissaoInicial, setFiltroEmissaoInicial] = useState("");
  const [filtroEmissaoFinal, setFiltroEmissaoFinal] = useState("");
  const [filtroStatusAprovacao, setFiltroStatusAprovacao] = useState("");
  const [filtroAprovadoPor, setFiltroAprovadoPor] = useState("");
  const [todoPeriodo, setTodoPeriodo] = useState(false);
  const [textoAtalhoPeriodo, setTextoAtalhoPeriodo] = useState('Atalhos de Período');

  const [loadingTable, setLoadingTable] = useState(false);
  const [statusConsulta, setStatusConsulta] = useState("idle");
  const [confirmacaoVolume, setConfirmacaoVolume] = useState({ open: false, total: 0, assinatura: "" });
  const assinaturaVolumeConfirmadaRef = useRef("");
  const [habilitarPdf, setHabilitarPdf] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);

  const [totalQuitadas, setTotalQuitadas] = useState(0);
  const [totalAVencer, setTotalAVencer] = useState(0);
  const [totalVencidas, setTotalVencidas] = useState(0);
  const [totalBrutaQuitadas, setTotalBrutaQuitadas] = useState(0);
  const [totalBrutaAVencer, setTotalBrutaAVencer] = useState(0);
  const [totalBrutaVencidas, setTotalBrutaVencidas] = useState(0);
  const [totalCompraBoletoQuitadas, setTotalCompraBoletoQuitadas] = useState(0);
  const [totalCompraBoletoAVencer, setTotalCompraBoletoAVencer] = useState(0);
  const [totalCompraBoletoVencidas, setTotalCompraBoletoVencidas] = useState(0);
  const [totalPagamentoQuitadas, setTotalPagamentoQuitadas] = useState(0);
  const [totalPagamentoAVencer, setTotalPagamentoAVencer] = useState(0);
  const [totalPagamentoVencidas, setTotalPagamentoVencidas] = useState(0);
  const [progressoLoading, setProgressoLoading] = useState(0);
  const quantidadeComissoesNegativas = listaFaturasIncluindoNegativas.filter(possuiComissaoNegativa).length;

  useEffect(() => {
    assinaturaVolumeConfirmadaRef.current = "";
  }, [
    filtroFilial,
    filtroRca,
    filtroAgenciador,
    filtroNota,
    filtroTransacao,
    checkPaga,
    checkAVencer,
    checkVencida,
    filtroPgCom,
    filtroEmissaoInicial,
    filtroEmissaoFinal,
    filtroStatusAprovacao,
    filtroAprovadoPor,
    todoPeriodo,
  ]);

  useEffect(() => {
    let intervalId;
    if (loadingTable) {
      setProgressoLoading(1);
      intervalId = setInterval(() => {
        setProgressoLoading((prev) => {
          if (prev >= 99) return 99;
          const next = prev + Math.floor(Math.random() * 5) + 1;
          return next > 99 ? 99 : next;
        });
      }, 150);
    } else {
      setProgressoLoading(100);
      const timeoutId = setTimeout(() => setProgressoLoading(0), 300);
      return () => {
        clearInterval(intervalId);
        clearTimeout(timeoutId);
      };
    }
    return () => clearInterval(intervalId);
  }, [loadingTable]);

  // const [nReq, setNReq] = useState(0)

  function abrirModalFatura(fatura) {
    if (fatura.terminouLoading) {
      let modalF = { ...fatura };
      setFaturaModal(modalF);
      setOpenModal(true);
      setLoadingModal(true);
      axios
        .get(URL_DADOS_VENDA + "?numeroTransacaoVenda=" + fatura.numeroTransacaoVenda + "&prestacao=" + fatura.prestacao)
        .then((response) => {
          if (response != undefined) {
            modalF.aprovacao = response.data.aprovada;
            modalF.aprovacaoComercial = response.data.aprovacaoComercial;
            modalF.aprovacaoFinanceiro = response.data.aprovacaoFinanceiro;
            modalF.comissaoPagaNoWinthor = response.data.comissaoPagaNoWinthor;
            modalF.dataAprovacaoComercial = response.data.dataAprovacaoComercial;
            modalF.dataAprovacaoFinanceiro = response.data.dataAprovacaoFinanceiro;
            modalF.dataPagamentoComissaoWinthor = response.data.dataPagamentoComissaoWinthor;
            modalF.motivoRejeicao = response.data.motivoRejeicao;
            modalF.rejeitada = response.data.rejeitada;
            modalF.tipoComissao = response.data.tipoComissao;
            modalF.valorComissaoSelecionada = response.data.valorComissaoSelecionada;
            modalF.responsavelAprovacaoComercial = response.data.responsavelAprovacaoComercial;
            modalF.responsavelAprovacaoFinanceiro = response.data.responsavelAprovacaoFinanceiro;
            modalF.valorAtualizado = response.data.valorAtualizado;
          }
          modalF = aplicarStatusCalculado(modalF);
          setFaturaModal(modalF);
          setLoadingModal(false);
        })
        .catch((error) => {
          setLoadingModal(false);
        });
    } else {
      Util.notify("Espere carregar todos os dados da fatura.");
    }
  }

  function fecharModalFatura() {
    setOpenModal(false);
    setFaturaModal(null);
  }

  function valorNumerico(valor) {
    return Number(valor) || 0;
  }

  function dataSemHora(data) {
    if (!data) return null;
    let dataObj;
    if (data instanceof Date) {
      dataObj = data;
    } else {
      let strData = String(data);
      if (strData.match(/^\d{4}-\d{2}-\d{2}$/)) {
        strData += "T00:00:00";
      }
      dataObj = new Date(strData);
    }
    if (Number.isNaN(dataObj.getTime())) return null;
    return new Date(dataObj.getFullYear(), dataObj.getMonth(), dataObj.getDate()).getTime();
  }

  function obterAssinaturaFiltros() {
    return JSON.stringify({
      filial: filtroFilial,
      rca: filtroRca,
      agenciador: filtroAgenciador,
      nota: String(filtroNota || "").trim(),
      transacao: String(filtroTransacao || "").trim(),
      status: { quitadas: checkPaga, aVencer: checkAVencer, vencidas: checkVencida },
      dataInicial: dataSemHora(filtroEmissaoInicial),
      dataFinal: dataSemHora(filtroEmissaoFinal),
      todoPeriodo,
      pgCom: filtroPgCom,
      statusAprovacao: filtroStatusAprovacao,
      aprovadoPor: filtroAprovadoPor,
    });
  }

  function validarFiltrosPesquisa(exibirMensagem = false) {
    const temNota = filtroNota && String(filtroNota).trim().length > 0;
    const temAgenciador = filtroAgenciador && filtroAgenciador.length > 0;
    const temRca = filtroRca && filtroRca.length > 0;
    const temDataInicial = Boolean(filtroEmissaoInicial);
    const temDataFinal = Boolean(filtroEmissaoFinal);
    const temPeriodoCompleto = !todoPeriodo && temDataInicial && temDataFinal;

    if (!todoPeriodo && temDataInicial !== temDataFinal) {
      if (exibirMensagem) {
        Util.notifyImportant("Informe as datas de emissão inicial e final para pesquisar por período.");
      }
      return false;
    }
    if (temPeriodoCompleto && dataSemHora(filtroEmissaoInicial) > dataSemHora(filtroEmissaoFinal)) {
      if (exibirMensagem) {
        Util.notifyImportant("A Data de Emissão Inicial não pode ser posterior à Data de Emissão Final.");
      }
      return false;
    }
    if (todoPeriodo && !temNota && !temAgenciador && !temRca) {
      if (exibirMensagem) {
        Util.notifyImportant("Para pesquisar em Todo o Período, informe o Número da Nota, um RCA ou um Agenciador.");
      }
      return false;
    }
    if (!todoPeriodo && !temPeriodoCompleto && !temNota && !temAgenciador && !temRca) {
      if (exibirMensagem) {
        Util.notifyImportant("Informe o período completo, o Número da Nota, um RCA ou um Agenciador.");
      }
      return false;
    }
    return true;
  }

  function limparResultadosPesquisa() {
    setListaFaturas([]);
    setListaFaturasIncluindoNegativas([]);
    setHabilitarPdf(false);
    setTotalQuitadas(0); setTotalAVencer(0); setTotalVencidas(0);
    setTotalBrutaQuitadas(0); setTotalBrutaAVencer(0); setTotalBrutaVencidas(0);
    setTotalCompraBoletoQuitadas(0); setTotalCompraBoletoAVencer(0); setTotalCompraBoletoVencidas(0);
    setTotalPagamentoQuitadas(0); setTotalPagamentoAVencer(0); setTotalPagamentoVencidas(0);
  }

  function obterStatusAprovacao(fatura) {
    if (fatura.rejeitada === true) return STATUS_APROVACAO.REJEITADA;
    if (fatura.aprovacao === true || fatura.aprovada === true) return STATUS_APROVACAO.APROVADA;
    if (fatura.statusAprovacao) return fatura.statusAprovacao;
    return STATUS_APROVACAO.PENDENTE;
  }

  function obterStatusComissao(fatura) {
    const statusAprovacao = obterStatusAprovacao(fatura);
    if (statusAprovacao === STATUS_APROVACAO.REJEITADA) return STATUS_APROVACAO.REJEITADA;
    if (statusAprovacao === STATUS_APROVACAO.PENDENTE && !fatura.statusPagamentoComissao) return STATUS_APROVACAO.PENDENTE;
    return fatura.statusPagamentoComissao || statusAprovacao;
  }

  function obterStatusPgComPermitidos() {
    if (!filtroPgCom) return [];
    if (filtroPgCom === STATUS_PG_COM_ABERTO_COM_PARCIAL) {
      return ["Em Aberto", "Parcialmente Pago"];
    }
    return [filtroPgCom];
  }

  function aplicarDadosAprovacao(fatura, dadosAprovacao) {
    if (!dadosAprovacao) return fatura;
    return {
      ...fatura,
      aprovacao: dadosAprovacao.aprovada,
      aprovacaoComercial: dadosAprovacao.aprovacaoComercial,
      aprovacaoFinanceiro: dadosAprovacao.aprovacaoFinanceiro,
      comissaoPagaNoWinthor: dadosAprovacao.comissaoPagaNoWinthor,
      dataAprovacaoComercial: dadosAprovacao.dataAprovacaoComercial,
      dataAprovacaoFinanceiro: dadosAprovacao.dataAprovacaoFinanceiro,
      dataPagamentoComissaoWinthor: dadosAprovacao.dataPagamentoComissaoWinthor,
      motivoRejeicao: dadosAprovacao.motivoRejeicao,
      rejeitada: dadosAprovacao.rejeitada,
      tipoComissao: dadosAprovacao.tipoComissao,
      valorComissaoSelecionada: dadosAprovacao.valorComissaoSelecionada,
      responsavelAprovacaoComercial: dadosAprovacao.responsavelAprovacaoComercial,
      responsavelAprovacaoFinanceiro: dadosAprovacao.responsavelAprovacaoFinanceiro,
      valorAtualizado: dadosAprovacao.valorAtualizado,
    };
  }

  function aplicarStatusCalculado(fatura) {
    const statusAprovacao = obterStatusAprovacao(fatura);
    const statusComissao = obterStatusComissao({ ...fatura, statusAprovacao });
    return { ...fatura, statusAprovacao, statusComissao };
  }

  function aplicarFiltrosDiretos(listaFaturas) {
    let lista = (listaFaturas || []).filter((f) => f != null);
    if (filtroFilial.length > 0) {
      const filtroStr = filtroFilial.map(String);
      lista = lista.filter((f) => filtroStr.includes(String(f.filial)));
    }
    if (filtroRca.length > 0) {
      const filtroStr = filtroRca.map(String);
      lista = lista.filter((f) => filtroStr.includes(String(f.idRCA)));
    }
    if (filtroAgenciador.length > 0) {
      const filtroStr = filtroAgenciador.map(String);
      lista = lista.filter((f) => filtroStr.includes(String(f.idAgenciador)));
    }
    if (filtroNota) {
      lista = lista.filter((f) => String(f.numeroNota).includes(filtroNota));
    }
    if (filtroTransacao && verificarTransacaoValida(filtroTransacao)) {
      lista = lista.filter((f) => String(f.numeroTransacaoVenda).includes(filtroTransacao));
    }
    if (!checkPaga) {
      lista = lista.filter((f) => f.statusFatura !== "Paga" && f.statusFatura !== "Quitada");
    }
    if (!checkAVencer) {
      lista = lista.filter((f) => f.statusFatura !== "A Vencer");
    }
    if (!checkVencida) {
      lista = lista.filter((f) => f.statusFatura !== "Vencida");
    }
    if (!todoPeriodo && (filtroEmissaoInicial || filtroEmissaoFinal)) {
      const dataInicial = dataSemHora(filtroEmissaoInicial);
      const dataFinal = dataSemHora(filtroEmissaoFinal);
      lista = lista.filter((f) => {
        const dataEmissao = dataSemHora(f.dataEmissao);
        if (!dataEmissao) return false;
        if (dataInicial && dataEmissao < dataInicial) return false;
        if (dataFinal && dataEmissao > dataFinal) return false;
        return true;
      });
    }
    return lista;
  }

  function aplicarFiltrosDetalhados(listaFaturas) {
    let lista = aplicarFiltrosDiretos(listaFaturas);
    const statusPgComPermitidos = obterStatusPgComPermitidos();
    if (statusPgComPermitidos.length > 0) {
      lista = lista.filter((f) => statusPgComPermitidos.includes(f.statusPagamentoComissao));
    }
    if (filtroStatusAprovacao) {
      lista = lista.filter((f) => obterStatusAprovacao(f) === filtroStatusAprovacao);
    }
    if (filtroAprovadoPor) {
      lista = lista.filter(
        (f) =>
          f.responsavelAprovacaoComercial === filtroAprovadoPor ||
          f.responsavelAprovacaoFinanceiro === filtroAprovadoPor
      );
    }
    return lista;
  }

  // 2.8 — Exportação Excel
  function executarExportarExcel() {
    if (!listaFaturas || listaFaturas.length === 0) return;

    const statusFaturaAtivos = Object.entries(excelStatusFatura)
      .filter(([, v]) => v)
      .map(([k]) => k);

    const statusComissaoAtivos = Object.entries(excelStatusComissao)
      .filter(([, v]) => v)
      .map(([k]) => k);

    const grupos = [
      { status: "Quitada",  label: "Faturas Quitadas" },
      { status: "A Vencer", label: "Faturas a Vencer" },
      { status: "Vencida",  label: "Faturas Vencidas" },
    ].filter((g) => statusFaturaAtivos.includes(g.status));

    const cabecalho = [
      "RCA", "Agenciador", "Cliente", "Nº NF - Parcela", "Forma Pagamento",
      "Emissão", "Vencimento", "Valor Bruto", "Vl. Compra/Boleto",
      "Vl. Pagamento", "Valor a Pagar", "Status Comissão"
    ];

    function fmtData(d) {
      if (!d) return "";
      return new Date(d).toLocaleDateString("pt-BR");
    }
    function fmtValor(v) {
      if (v == null) return "";
      return v.toLocaleString("pt-br", { style: "currency", currency: "BRL" });
    }

    const wb = XLSX.utils.book_new();
    const allRows = [];
    let totalGerado = 0;

    grupos.forEach((grupo) => {
      // Filtrar por status de fatura E por status de comissão selecionados
      const faturasGrupo = listaFaturas.filter((f) => {
        if (f.statusFatura !== grupo.status) return false;
        if (f.rejeitada === true && !statusComissaoAtivos.includes("Rejeitada")) return false;
        const stComissao = f.statusComissao || obterStatusComissao(f);
        return statusComissaoAtivos.some((s) => stComissao === s || stComissao?.includes(s));
      });

      if (faturasGrupo.length === 0) return;
      totalGerado += faturasGrupo.length;

      allRows.push([grupo.label]);
      allRows.push(cabecalho);

      faturasGrupo.forEach((f) => {
        allRows.push([
          f.idRCA,
          f.nomeAgenciador,
          f.nomeCliente,
          f.numeroNota + " - " + f.prestacao,
          f.tipoCobranca,
          fmtData(f.dataEmissao),
          fmtData(f.dataVencimento),
          fmtValor(f.valorComissaoBruta),
          fmtValor(f.valorComissaoNfeRepresentacoes),
          fmtValor(f.valorComissaoNfe),
          fmtValor(f.valorAPagar),
          f.statusComissao || obterStatusComissao(f),
        ]);
      });

      const bruta  = faturasGrupo.reduce((s, f) => s + (f.valorComissaoBruta || 0), 0);
      const compra = faturasGrupo.reduce((s, f) => s + (f.valorComissaoNfeRepresentacoes || 0), 0);
      const pag    = faturasGrupo.reduce((s, f) => s + (f.valorComissaoNfe || 0), 0);
      const apagar = faturasGrupo.reduce((s, f) => s + (f.valorAPagar || 0), 0);
      allRows.push(["", "", "", "", "", "", "TOTAL",
        fmtValor(bruta), fmtValor(compra), fmtValor(pag), fmtValor(apagar), ""]);
      allRows.push([]);
    });

    if (totalGerado === 0) {
      Util.notifyImportant("Nenhum registro encontrado com os status selecionados.");
      return;
    }

    const ws = XLSX.utils.aoa_to_sheet(allRows);
    ws["!cols"] = [
      { wch: 8 }, { wch: 22 }, { wch: 30 }, { wch: 14 }, { wch: 20 },
      { wch: 12 }, { wch: 12 }, { wch: 16 }, { wch: 18 }, { wch: 16 },
      { wch: 16 }, { wch: 18 }
    ];

    XLSX.utils.book_append_sheet(wb, ws, "Comissões");
    const dataHoje = new Date().toLocaleDateString("pt-BR").replace(/\//g, "-");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
    saveAs(data, `Relatorio_Comissoes_${dataHoje}.xlsx`);
    setOpenModalExcel(false);
  }

  function abrirModalExportarExcel() {
    setOpenModalExcel(true);
  }

  async function executarGerarPdf() {
    const statusFaturaAtivos = Object.entries(pdfStatusFatura)
      .filter(([, v]) => v)
      .map(([k]) => k);
    const statusComissaoAtivos = Object.entries(pdfStatusComissao)
      .filter(([, v]) => v)
      .map(([k]) => k);

    const dadosFiltrados = listaFaturas.filter((f) => {
      if (!statusFaturaAtivos.includes(f.statusFatura)) return false;
      if (f.rejeitada === true && !statusComissaoAtivos.includes('Rejeitada')) return false;
      const stComissao = f.statusComissao || obterStatusComissao(f);
      return statusComissaoAtivos.some((s) => stComissao === s || stComissao?.includes(s));
    });

    if (dadosFiltrados.length === 0) {
      Util.notifyImportant('Nenhum registro encontrado com os status selecionados.');
      return;
    }

    // Recalcular totais com os dados filtrados
    let tQuitadas = 0, tAVencer = 0, tVencidas = 0;
    let tBrutaQ = 0, tBrutaAV = 0, tBrutaV = 0;
    let tCBQ = 0, tCBAV = 0, tCBV = 0;
    let tPagQ = 0, tPagAV = 0, tPagV = 0;
    dadosFiltrados.filter((f) => f.rejeitada !== true).forEach((f) => {
      const bruta = valorNumerico(f.valorComissaoBruta);
      const compra = valorNumerico(f.valorComissaoNfeRepresentacoes);
      const pag = valorNumerico(f.valorComissaoNfe);
      const pagar = valorNumerico(f.valorAPagar);
      if (f.statusFatura === 'Quitada') {
        tBrutaQ += bruta; tCBQ += compra; tPagQ += pag; tQuitadas += pagar;
      } else if (f.statusFatura === 'A Vencer') {
        tBrutaAV += bruta; tCBAV += compra; tPagAV += pag; tAVencer += pagar;
      } else if (f.statusFatura === 'Vencida') {
        tBrutaV += bruta; tCBV += compra; tPagV += pag; tVencidas += pagar;
      }
    });

    const blob = await pdf(<RelatorioPdfConsulta data={dadosFiltrados}
      totalQuitadas={tQuitadas} totalAVencer={tAVencer} totalVencidas={tVencidas}
      totalBrutaQuitadas={tBrutaQ} totalBrutaAVencer={tBrutaAV} totalBrutaVencidas={tBrutaV}
      totalCompraBoletoQuitadas={tCBQ} totalCompraBoletoAVencer={tCBAV} totalCompraBoletoVencidas={tCBV}
      totalPagamentoQuitadas={tPagQ} totalPagamentoAVencer={tPagAV} totalPagamentoVencidas={tPagV}
    />).toBlob();
    const blobURL = URL.createObjectURL(blob);
    window.open(blobURL);
    setOpenModalPdf(false);
  }

  async function montarPdfConsulta(data) {
    const blob = await pdf(<RelatorioPdfConsulta data={data}
      totalQuitadas={totalQuitadas} totalAVencer={totalAVencer} totalVencidas={totalVencidas}
      totalBrutaQuitadas={totalBrutaQuitadas} totalBrutaAVencer={totalBrutaAVencer} totalBrutaVencidas={totalBrutaVencidas}
      totalCompraBoletoQuitadas={totalCompraBoletoQuitadas} totalCompraBoletoAVencer={totalCompraBoletoAVencer} totalCompraBoletoVencidas={totalCompraBoletoVencidas}
      totalPagamentoQuitadas={totalPagamentoQuitadas} totalPagamentoAVencer={totalPagamentoAVencer} totalPagamentoVencidas={totalPagamentoVencidas}
    />).toBlob();
    let blobURL = URL.createObjectURL(blob);
    window.open(blobURL);
  }

  useEffect(() => {
    setLoadingTable(false);
    sessionStorage.setItem("nReq", 0);
    if (AuthenticationService.isUserLoggedIn()) {
      let usuario = AuthenticationService.getUsuario();
      setUsuario(usuario);
      let formData = new FormData();
      formData.append("chave", CHAVE_WINTHOR_SERVICE);

      axios
        .post(URL_FILIAL, formData)
        .then((response) => {
          carregarListaFilial(response.data);
        })
        .catch((error) => {
          Util.tratarErro(error);
        });

      axios
        .post(URL_AGENCIADOR, formData)
        .then((response) => {
          carregarListaAgenciador(response.data);
        })
        .catch((error) => {
          Util.tratarErro(error);
        });

      axios
        .post(URL_RCA, formData)
        .then((response) => {
          carregarListaRCA(response.data);
        })
        .catch((error) => {
          Util.tratarErro(error);
        });

      axios
        .post(URL_STATUS_FATURA, formData)
        .then((response) => {
          carregarListaStatusFatura(response.data);
        })
        .catch((error) => {
          Util.tratarErro(error);
        });

      axios
        .get(URL_USUARIO)
        .then((response) => {
          carregarListaAprovadores(response.data.filter((user) => user.roles[0] === "Comercial" || user.roles[0] === "Financeiro"));
        })
        .catch((error) => {
          Util.tratarErro(error);
        });
    } else {
      AuthenticationService.logout();
    }
  }, []);

  function carregarListaFilial(filiais) {
    let listaF = [];
    filiais.forEach((filial) => {
      let f = {
        key: filial.codigo,
        value: filial.codigo,
        text: filial.razaoSocial, // .replace(/ - .+$/, '')   // + " - " + filial.cidade    // Remove a cidade do final da razão social, caso já esteja mesclada no formato "Nome - Cidade"
      };
      listaF.push(f);
    });
    setListaFiliais(listaF);
  }

  function carregarListaAgenciador(agenciadores) {
    let listaA = [];
    agenciadores.forEach((a) => {
      let agenciador = {
        key: a.codusur,
        value: a.codusur,
        text: a.codusur + " - " + a.nome,
      };
      listaA.push(agenciador);
    });
    setListaAgenciadores(listaA);
  }

  function carregarListaRCA(rcas) {
    let listaR = [];
    rcas.forEach((r) => {
      let rca = {
        key: r.codusur,
        value: r.codusur,
        text: r.codusur + " - " + r.nome,
      };
      listaR.push(rca);
    });
    setListaRCA(listaR);
  }

  function carregarListaStatusFatura(ObjetoStatusFatura) {
    let listaStatusFatura = Object.values(ObjetoStatusFatura);
    let listaSF = [];
    let statusFatura = {
      key: "n",
      value: "",
      text: "Selecione",
    };
    listaSF.push(statusFatura);
    for (let i = 0; i < listaStatusFatura.length; i++) {
      statusFatura = {
        key: i,
        value: listaStatusFatura[i],
        text: listaStatusFatura[i],
      };
      listaSF.push(statusFatura);
    }
    setListaStatusFatura(listaSF);
  }

  function carregarListaAprovadores(users) {
    let listaU = [];
    let selecione = { key: "n", value: "", text: "Selecione" };
    listaU.push(selecione);
    users.forEach((u) => {
      let user = {
        key: u.id,
        value: u.nome,
        text: u.nome + " - " + u.roles[0],
      };
      listaU.push(user);
    });
    setListaAprovadores(listaU);
  }

  function filtrarComissoes() {
    if (!validarFiltrosPesquisa(true)) {
      setStatusConsulta("idle");
      limparResultadosPesquisa();
      return;
    }
    const assinaturaPesquisa = obterAssinaturaFiltros();
    setLoadingTable(true);
    setStatusConsulta("loading");
    limparResultadosPesquisa();
    sessionStorage.setItem("nReq", parseInt(sessionStorage.getItem("nReq")) + 1);
    let nReqAtual = sessionStorage.getItem("nReq");

    // Função auxiliar: monta FormData para consulta em lote com filtros de data
    function montarFormLote(listaTransacoes) {
      let formConsultaLote = new FormData();
      formConsultaLote.append("loteTransacao", listaTransacoes);
      formConsultaLote.append("size", 100000);
      formConsultaLote.append("chave", CHAVE_WINTHOR_SERVICE);
      return formConsultaLote;
    }

    function montarFormConsultaPadrao() {
      let formData = new FormData();
      formData.append("chave", CHAVE_WINTHOR_SERVICE);
      formData.append("filiais", filtroFilial.join(","));
      formData.append("rca", filtroRca.join(","));
      formData.append("idsAgenciador", filtroAgenciador.map(id => "'" + id + "'").join(","));
      formData.append("numeroNota", filtroNota);
      if (verificarTransacaoValida(filtroTransacao)) {
        formData.append("numeroTransacao", filtroTransacao);
      }
      let statusSelecionado = "";
      if (checkPaga && !checkAVencer && !checkVencida) statusSelecionado = "Paga";
      else if (!checkPaga && checkAVencer && !checkVencida) statusSelecionado = "A Vencer";
      else if (!checkPaga && !checkAVencer && checkVencida) statusSelecionado = "Vencida";
      formData.append("statusFatura", statusSelecionado);
      const formatarParaEnvio = (val) => {
        if (!val) return "";
        if (val instanceof Date) {
          const mes = String(val.getMonth() + 1).padStart(2, "0");
          const dia = String(val.getDate()).padStart(2, "0");
          return `${dia}/${mes}/${val.getFullYear()}`;
        }
        const parsed = new Date(val + "T00:00:00");
        if (Number.isNaN(parsed.getTime())) return String(val);
        const mes = String(parsed.getMonth() + 1).padStart(2, "0");
        const dia = String(parsed.getDate()).padStart(2, "0");
        return `${dia}/${mes}/${parsed.getFullYear()}`;
      };

      if (filtroEmissaoInicial && filtroEmissaoFinal && !todoPeriodo) {
        formData.append("dataEmissaoInicial", formatarParaEnvio(filtroEmissaoInicial));
        formData.append("dataEmissaoFinal", formatarParaEnvio(filtroEmissaoFinal));
      } else if (filtroEmissaoInicial && !todoPeriodo) {
        formData.append("dataEmissaoInicial", formatarParaEnvio(filtroEmissaoInicial));
      } else if (filtroEmissaoFinal && !todoPeriodo) {
        formData.append("dataEmissaoFinal", formatarParaEnvio(filtroEmissaoFinal));
      }
      formData.append("size", 100000);
      return formData;
    }

    // Função auxiliar: trata lista vazia
    function tratarListaVazia() {
      limparResultadosPesquisa();
      setLoadingTable(false);
      setStatusConsulta("success");
    }

    const executarBuscaWinthor = (formDataCustom) => {
      formDataCustom.set("size", "1");
      axios
        .post(URL_COMISSOES, formDataCustom)
        .then(async (responseContagem) => {
          if (nReqAtual === sessionStorage.getItem("nReq")) {
            const totalEncontrado = Number(responseContagem.data.totalElements || 0);
            if (totalEncontrado > LIMITE_CONFIRMACAO_CONSULTA && assinaturaVolumeConfirmadaRef.current !== assinaturaPesquisa) {
              setConfirmacaoVolume({ open: true, total: totalEncontrado, assinatura: assinaturaPesquisa });
              setStatusConsulta("awaiting_confirmation");
              setLoadingTable(false);
              return;
            }
            formDataCustom.set("size", "100000");
            const response = await axios.post(URL_COMISSOES, formDataCustom);
            if (nReqAtual !== sessionStorage.getItem("nReq")) return;
            const listaFiltrada = aplicarFiltrosDiretos(response.data.content);
            await completarListaFatura(listaFiltrada, nReqAtual);
            if (nReqAtual !== sessionStorage.getItem("nReq")) return;
            setStatusConsulta("success");
            setLoadingTable(false);
          }
        })
        .catch((error) => {
          if (nReqAtual !== sessionStorage.getItem("nReq")) return;
          setLoadingTable(false);
          setStatusConsulta("error");
          setHabilitarPdf(false);
          Util.tratarErro(error);
        });
    };

    if (filtroPgCom || filtroStatusAprovacao || filtroAprovadoPor) {
      let promisesIn = [];
      let promisesNotIn = [];

      if (filtroPgCom) {
        const statusList = filtroPgCom === STATUS_PG_COM_ABERTO_COM_PARCIAL
          ? ["Em Aberto", "Parcialmente Pago"]
          : [filtroPgCom];

        const promisesPgCom = statusList.map((status) => {
          let formStatusPgCom = new FormData();
          formStatusPgCom.append("status", status);
          formStatusPgCom.append("chave", CHAVE_WINTHOR_SERVICE);
          return axios.post(URL_CONSULTAR_STATUS_PGCOM, formStatusPgCom);
        });

        promisesIn.push(
          Promise.all(promisesPgCom).then(responses => {
            let listaRecnum = [];
            responses.forEach((r) => {
              if (r.data) listaRecnum = listaRecnum.concat(r.data.map((f) => f.recnum));
            });
            listaRecnum = [...new Set(listaRecnum)];
            if (listaRecnum.length === 0) return [];
            let formRecnum = new FormData();
            formRecnum.append("listaRecnum", listaRecnum.join(","));
            return axios.post(URL_OBTER_RELACIONAMENTO_EMLOTE, formRecnum).then(res2 => 
              res2.data.map(f => f.comissaoVenda.numeroTransacaoVenda + "-" + f.comissaoVenda.prestacao)
            );
          })
        );
      }

      if (filtroAprovadoPor) {
        let formAprovadoPor = new FormData();
        formAprovadoPor.append("responsavelAprovacao", filtroAprovadoPor);
        promisesIn.push(
          axios.post(URL_APROVADO_POR, formAprovadoPor).then(res => 
            res.data.map(f => f.numeroTransacaoVenda + "-" + f.prestacao)
          )
        );
      }

      if (filtroStatusAprovacao) {
        let formStatusApro = new FormData();
        formStatusApro.append("statusAprovacao", filtroStatusAprovacao);
        if (filtroStatusAprovacao === STATUS_APROVACAO.PENDENTE) {
          promisesNotIn.push(
            axios.post(URL_CONSULTAR_STATUS_APRO, formStatusApro).then(res => 
              res.data.map(f => f.numeroTransacaoVenda + "-" + f.prestacao)
            )
          );
        } else {
          promisesIn.push(
            axios.post(URL_CONSULTAR_STATUS_APRO, formStatusApro).then(res => 
              res.data.map(f => f.numeroTransacaoVenda + "-" + f.prestacao)
            )
          );
        }
      }

      Promise.all([...promisesIn, ...promisesNotIn])
        .then(results => {
          let resultsIn = results.slice(0, promisesIn.length);
          let resultsNotIn = results.slice(promisesIn.length);

          let intersectedIn = null;
          if (resultsIn.length > 0) {
            intersectedIn = resultsIn[0];
            for (let i = 1; i < resultsIn.length; i++) {
              intersectedIn = intersectedIn.filter(k => resultsIn[i].includes(k));
            }
            if (intersectedIn.length === 0) {
              if (nReqAtual === sessionStorage.getItem("nReq")) {
                tratarListaVazia();
              }
              return;
            }
          }

          let unitedNotIn = null;
          if (resultsNotIn.length > 0) {
            unitedNotIn = [...new Set(resultsNotIn.flat())];
          }

          let formCustom = montarFormConsultaPadrao();
          if (intersectedIn !== null && intersectedIn.length > 0) {
            formCustom.append("loteTransacaoIn", intersectedIn.join(","));
          }
          if (unitedNotIn !== null && unitedNotIn.length > 0) {
            formCustom.append("loteTransacaoNotIn", unitedNotIn.join(","));
          }

          executarBuscaWinthor(formCustom);
        })
        .catch((error) => {
          if (nReqAtual !== sessionStorage.getItem("nReq")) return;
          setLoadingTable(false);
          setStatusConsulta("error");
          setHabilitarPdf(false);
          Util.tratarErro(error);
        });
    } else {
      executarBuscaWinthor(montarFormConsultaPadrao());
    }
  }

  function resetarFiltros() {
    sessionStorage.setItem("nReq", parseInt(sessionStorage.getItem("nReq")) + 1);
    setFiltroFilial([]);
    setFiltroRca([]);
    setFiltroAgenciador([]);
    setFiltroTransacao("");
    setFiltroNota("");
    setCheckPaga(true);
    setCheckAVencer(true);
    setCheckVencida(true);
    setFiltroEmissaoInicial(null);
    setFiltroEmissaoFinal(null);
    setTextoAtalhoPeriodo('Atalhos de Período');
    setFiltroPgCom("");
    setFiltroAprovadoPor("");
    setFiltroStatusAprovacao("");
    setTodoPeriodo(false);
    setLoadingTable(false);
    setStatusConsulta("idle");
    setConfirmacaoVolume({ open: false, total: 0, assinatura: "" });
    assinaturaVolumeConfirmadaRef.current = "";
    limparResultadosPesquisa();
  }

  function possuiComissaoNegativa(fatura) {
    return valorNumerico(fatura?.valorComissaoBruta) < 0;
  }

  function atualizarResultadosVisiveis(listaCompleta, ocultarNegativas = ocultarComissoesNegativas) {
    const listaVisivel = ocultarNegativas
      ? (listaCompleta || []).filter((fatura) => !possuiComissaoNegativa(fatura))
      : (listaCompleta || []);

    let tQuitadas = 0, tAVencer = 0, tVencidas = 0;
    let tBrutaQ = 0, tBrutaAV = 0, tBrutaV = 0;
    let tCBQ = 0, tCBAV = 0, tCBV = 0;
    let tPagQ = 0, tPagAV = 0, tPagV = 0;

    listaVisivel.filter((f) => f.rejeitada !== true).forEach((f) => {
      const bruta = valorNumerico(f.valorComissaoBruta);
      const compra = valorNumerico(f.valorComissaoNfeRepresentacoes);
      const pag = valorNumerico(f.valorComissaoNfe);
      const pagar = valorNumerico(f.valorAPagar);
      if (f.statusFatura === "Quitada") {
        tBrutaQ += bruta; tCBQ += compra; tPagQ += pag; tQuitadas += pagar;
      } else if (f.statusFatura === "A Vencer") {
        tBrutaAV += bruta; tCBAV += compra; tPagAV += pag; tAVencer += pagar;
      } else if (f.statusFatura === "Vencida") {
        tBrutaV += bruta; tCBV += compra; tPagV += pag; tVencidas += pagar;
      }
    });

    setListaFaturas(listaVisivel);
    setHabilitarPdf(listaVisivel.length > 0);
    setTotalBrutaQuitadas(tBrutaQ);
    setTotalBrutaAVencer(tBrutaAV);
    setTotalBrutaVencidas(tBrutaV);
    setTotalCompraBoletoQuitadas(tCBQ);
    setTotalCompraBoletoAVencer(tCBAV);
    setTotalCompraBoletoVencidas(tCBV);
    setTotalPagamentoQuitadas(tPagQ);
    setTotalPagamentoAVencer(tPagAV);
    setTotalPagamentoVencidas(tPagV);
    setTotalQuitadas(tQuitadas);
    setTotalAVencer(tAVencer);
    setTotalVencidas(tVencidas);
  }

  function alterarVisibilidadeComissoesNegativas(ocultar) {
    setOcultarComissoesNegativas(ocultar);
    atualizarResultadosVisiveis(listaFaturasIncluindoNegativas, ocultar);
  }

  function cancelarPesquisaVolumosa() {
    sessionStorage.setItem("nReq", parseInt(sessionStorage.getItem("nReq")) + 1);
    setConfirmacaoVolume({ open: false, total: 0, assinatura: "" });
    setLoadingTable(false);
    setStatusConsulta("idle");
    limparResultadosPesquisa();
  }

  function continuarPesquisaVolumosa() {
    assinaturaVolumeConfirmadaRef.current = confirmacaoVolume.assinatura;
    setConfirmacaoVolume({ open: false, total: 0, assinatura: "" });
    filtrarComissoes();
  }

  function aplicarPeriodoRapido(periodo) {
    if (!periodo) return;
    setTodoPeriodo(false);
    
    const hoje = new Date();
    let dataIni = new Date();
    let dataFim = new Date();

    let texto = 'Atalhos de Período';

    if (periodo === "semana") {
      const diaSemana = hoje.getDay(); 
      const diffSegunda = hoje.getDate() - diaSemana + (diaSemana === 0 ? -6 : 1); 
      dataIni = new Date(hoje.setDate(diffSegunda));
      dataFim = new Date(dataIni);
      dataFim.setDate(dataIni.getDate() + 6);
      texto = 'Esta Semana';
    } else if (periodo === "mes") {
      dataIni = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
      dataFim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
      texto = 'Este Mês';
    } else if (periodo === "mes_passado") {
      dataIni = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
      dataFim = new Date(hoje.getFullYear(), hoje.getMonth(), 0);
      texto = 'Mês Passado';
    } else if (periodo === "3_meses") {
      dataIni = new Date(hoje.getFullYear(), hoje.getMonth() - 3, hoje.getDate());
      dataFim = new Date();
      texto = 'Últimos 3 Meses';
    } else if (periodo === "6_meses") {
      dataIni = new Date(hoje.getFullYear(), hoje.getMonth() - 6, hoje.getDate());
      dataFim = new Date();
      texto = 'Últimos 6 Meses';
    } else if (periodo === "1_ano") {
      dataIni = new Date(hoje.getFullYear() - 1, hoje.getMonth(), hoje.getDate());
      dataFim = new Date();
      texto = 'Último 1 Ano';
    } else if (periodo === "hoje") {
      dataIni = new Date();
      dataFim = new Date();
      texto = 'Hoje';
    }

    setFiltroEmissaoInicial(dataIni);
    setFiltroEmissaoFinal(dataFim);
    setTextoAtalhoPeriodo(texto);
  }

  function verificarTransacaoValida(transacao) {
    if (transacao.length >= 6 ) {
      return true;
    }
    return false;
  }
  function verificarNumero(e) {
    const re = /^[0-9][\-\d]*(,\d+)?$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      return e.target.value;
    } else {
      return filtroTransacao;
    }
  }
  async function completarListaFatura(listaF, nReqAtual) {
    // Remover nulos que o backend pode retornar em alguns índices do array
    const listaValida = (listaF || []).filter((f) => f != null);
    if (listaValida.length > 0) {
      // 2.7 — Ordenar por Nº NF (numérico) e Parcela (numérica)
      let listaFaturasAtualizadas = [...listaValida].sort((a, b) => {
        const notaA = parseInt(a.numeroNota, 10) || 0;
        const notaB = parseInt(b.numeroNota, 10) || 0;
        if (notaA !== notaB) return notaA - notaB;
        const prestA = parseInt(a.prestacao, 10) || 0;
        const prestB = parseInt(b.prestacao, 10) || 0;
        return prestA - prestB;
      });

      const chunkSize = 20;
      let processadas = 0;
      const totalFaturas = listaFaturasAtualizadas.length;

      let loteStr = listaFaturasAtualizadas.map(f => f.numeroTransacaoVenda + "-" + f.prestacao).join(",");
      let formLote = new FormData();
      formLote.append("loteTransacao", loteStr);

      const responseLote = await axios.post(URL_DADOS_VENDA_LOTE, formLote).catch(() => {});
      let mapRes = {};
      if (responseLote && responseLote.data) {
         responseLote.data.forEach(d => mapRes[d.numeroTransacaoVenda + "-" + d.prestacao] = d);
      }

      for (let i = 0; i < totalFaturas; i += chunkSize) {
        const chunk = listaFaturasAtualizadas.slice(i, i + chunkSize);
        
        await Promise.all(chunk.map(async (fatura, indexInChunk) => {
          let faturaAtualizada = { ...fatura };
          let formData = new FormData();
          formData.append("numeroTransacaoVenda", fatura.numeroTransacaoVenda);
          formData.append("prestacao", fatura.prestacao);
          const response1 = await axios.post(URL_OBTER_RELACIONAMENTO, formData).catch((error) => {
            Util.logarErro(error);
            return null;
          });

          if (response1 && response1.data) {
            faturaAtualizada = aplicarDadosAprovacao(faturaAtualizada, response1.data.comissaoVenda);
            let formData2 = new FormData();
            formData2.append("chave", CHAVE_WINTHOR_SERVICE);
            const response2 = await axios.post(URL_LANCAMENTO + "/" + response1.data.recnum, formData2).catch((error) => {
              Util.logarErro(error);
              return null;
            });
            if (response2 && response2.data) {
              faturaAtualizada.dataEncerramentoComercial = response2.data.dataEncerramentoComercial;
              faturaAtualizada.statusDesdobramento = response2.data.statusDesdobramento;
              faturaAtualizada.statusPagamentoComissao = response2.data.statusPagamentoComissao;
              faturaAtualizada.valorAPagar = response2.data.valorAPagar;
            }
          } else {
            let resData = mapRes[fatura.numeroTransacaoVenda + "-" + fatura.prestacao];
            if (resData != undefined) {
              faturaAtualizada = aplicarDadosAprovacao(faturaAtualizada, resData);
            }
          }

          faturaAtualizada.terminouLoading = true;
          listaFaturasAtualizadas[i + indexInChunk] = aplicarStatusCalculado(faturaAtualizada);
        }));

        if (nReqAtual !== sessionStorage.getItem("nReq")) return;

        processadas += chunk.length;
      }
      if (nReqAtual === sessionStorage.getItem("nReq")) {
        const listaFiltrada = aplicarFiltrosDetalhados(listaFaturasAtualizadas);
        setListaFaturasIncluindoNegativas(listaFiltrada);
        atualizarResultadosVisiveis(listaFiltrada);
      }
    } else {
      setListaFaturas([]);
      setListaFaturasIncluindoNegativas([]);
      setHabilitarPdf(false);
      setTotalQuitadas(0);
      setTotalAVencer(0);
      setTotalVencidas(0);
      setTotalBrutaQuitadas(0); setTotalBrutaAVencer(0); setTotalBrutaVencidas(0);
      setTotalCompraBoletoQuitadas(0); setTotalCompraBoletoAVencer(0); setTotalCompraBoletoVencidas(0);
      setTotalPagamentoQuitadas(0); setTotalPagamentoAVencer(0); setTotalPagamentoVencidas(0);
    }
  }

  return (
    <div>
      <MenuSistema openModal={openModal || openModalExcel || openModalPdf || confirmacaoVolume.open} perfil={usuario.perfil} nome={usuario.nome} />

      <Modal
        size="tiny"
        centered
        open={confirmacaoVolume.open}
        closeOnDimmerClick={false}
        closeOnEscape={false}
      >
        <Modal.Header style={{ color: "#2a5faa" }}>
          <Icon name="warning sign" color="orange" />
          Pesquisa com muitos resultados
        </Modal.Header>
        <Modal.Content>
          <p style={{ fontSize: "1.1rem", lineHeight: 1.6 }}>
            Esta pesquisa pode retornar <strong>{confirmacaoVolume.total.toLocaleString("pt-BR")} vendas agenciadas</strong>.
            O processamento pode levar alguns minutos e consumir mais recursos. Deseja continuar?
          </p>
          {confirmacaoVolume.total > 1000 && (
            <Message warning icon>
              <Icon name="filter" />
              <Message.Content>
                Recomendamos reduzir o período ou informar filtros mais específicos antes de continuar.
              </Message.Content>
            </Message>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" icon="filter" content="Revisar filtros" onClick={cancelarPesquisaVolumosa} />
          <Button color="blue" icon="check" content="Continuar pesquisa" onClick={continuarPesquisaVolumosa} />
        </Modal.Actions>
      </Modal>

      {/* ===== MODAL GERAR PDF ===== */}
      <Modal
        open={openModalPdf}
        onClose={() => setOpenModalPdf(false)}
        size="small"
        closeOnDimmerClick
        closeIcon
      >
        <Modal.Header>
          <Icon name="file pdf" color="red" />
          Gerar PDF — Selecionar Status
        </Modal.Header>
        <Modal.Content>
          <p style={{ color: '#555', marginBottom: '1.2rem' }}>
            Selecione quais <strong>status de fatura</strong> e <strong>status de comissão</strong> deseja incluir no relatório PDF.
          </p>

          {/* Status de Fatura */}
          <Header as="h5" dividing style={{ color: '#444', marginBottom: '0.8rem' }}>
            <Icon name="tag" />
            Status da Fatura
          </Header>
          <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', marginBottom: '1.5rem' }}>
            {Object.keys(pdfStatusFatura).map((status) => (
              <div
                key={status}
                onClick={() => setPdfStatusFatura(prev => ({ ...prev, [status]: !prev[status] }))}
                style={{
                  display: 'flex', alignItems: 'center', gap: '0.5rem',
                  cursor: 'pointer', userSelect: 'none',
                  padding: '0.5rem 1rem',
                  borderRadius: '8px',
                  border: `2px solid ${pdfStatusFatura[status] ? '#db2828' : '#ccc'}`,
                  background: pdfStatusFatura[status] ? '#fff5f5' : '#fafafa',
                  transition: 'all 0.15s',
                  fontWeight: pdfStatusFatura[status] ? '600' : '400',
                  color: pdfStatusFatura[status] ? '#db2828' : '#888',
                }}
              >
                <Icon
                  name={pdfStatusFatura[status] ? 'check square' : 'square outline'}
                  style={{ margin: 0, color: pdfStatusFatura[status] ? '#db2828' : '#ccc' }}
                />
                {status === 'Quitada' ? 'Quitada / Paga' : status}
              </div>
            ))}
          </div>

          {/* Status de Comissão */}
          <Header as="h5" dividing style={{ color: '#444', marginBottom: '0.8rem' }}>
            <Icon name="tasks" />
            Status de Comissão
          </Header>
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', marginBottom: '0.5rem' }}>
            {Object.keys(pdfStatusComissao).map((status) => {
              const ativo = pdfStatusComissao[status];
              return (
                <div
                  key={status}
                  onClick={() => setPdfStatusComissao(prev => ({ ...prev, [status]: !prev[status] }))}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '0.5rem',
                    cursor: 'pointer', userSelect: 'none',
                    padding: '0.5rem 1rem',
                    borderRadius: '8px',
                    border: `2px solid ${ativo ? '#db2828' : '#ccc'}`,
                    background: ativo ? '#fff5f5' : '#fafafa',
                    transition: 'all 0.15s',
                    fontWeight: ativo ? '600' : '400',
                    color: ativo ? '#db2828' : '#888',
                  }}
                >
                  <Icon
                    name={ativo ? 'check square' : 'square outline'}
                    style={{ margin: 0, color: ativo ? '#db2828' : '#ccc' }}
                  />
                  {status}
                </div>
              );
            })}
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            basic
            color="grey"
            onClick={() => {
              setPdfStatusFatura({ Quitada: true, 'A Vencer': true, Vencida: true });
              setPdfStatusComissao({ Pendente: true, 'Em Aberto': true, 'Parcialmente Pago': true, Aprovada: true, Rejeitada: true, Pago: false });
            }}
          >
            <Icon name="redo" /> Restaurar Padrões
          </Button>
          <Button color="grey" onClick={() => setOpenModalPdf(false)}>
            Cancelar
          </Button>
          <Button
            color="red"
            icon
            labelPosition="left"
            onClick={() => executarGerarPdf()}
          >
            <Icon name="file pdf" />
            Gerar PDF
          </Button>
        </Modal.Actions>
      </Modal>
      {/* ===== FIM MODAL GERAR PDF ===== */}

      {/* ===== MODAL EXPORTAR EXCEL ===== */}
      <Modal
        open={openModalExcel}
        onClose={() => setOpenModalExcel(false)}
        size="small"
        closeOnDimmerClick
        closeIcon
      >
        <Modal.Header>
          <Icon name="file excel" color="green" />
          Exportar Excel — Selecionar Status
        </Modal.Header>
        <Modal.Content>
          <p style={{ color: '#555', marginBottom: '1.2rem' }}>
            Selecione quais <strong>status de fatura</strong> e <strong>status de comissão</strong> deseja incluir no relatório Excel.
          </p>

          {/* Status de Fatura */}
          <Header as="h5" dividing style={{ color: '#444', marginBottom: '0.8rem' }}>
            <Icon name="tag" />
            Status da Fatura
          </Header>
          <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', marginBottom: '1.5rem' }}>
            {Object.keys(excelStatusFatura).map((status) => (
              <div
                key={status}
                onClick={() => setExcelStatusFatura(prev => ({ ...prev, [status]: !prev[status] }))}
                style={{
                  display: 'flex', alignItems: 'center', gap: '0.5rem',
                  cursor: 'pointer', userSelect: 'none',
                  padding: '0.5rem 1rem',
                  borderRadius: '8px',
                  border: `2px solid ${excelStatusFatura[status] ? '#21ba45' : '#ccc'}`,
                  background: excelStatusFatura[status] ? '#f0fff4' : '#fafafa',
                  transition: 'all 0.15s',
                  fontWeight: excelStatusFatura[status] ? '600' : '400',
                  color: excelStatusFatura[status] ? '#21ba45' : '#888',
                }}
              >
                <Icon
                  name={excelStatusFatura[status] ? 'check square' : 'square outline'}
                  color={excelStatusFatura[status] ? 'green' : 'grey'}
                  style={{ margin: 0 }}
                />
                {status === 'Quitada' ? 'Quitada / Paga' : status}
              </div>
            ))}
          </div>

          {/* Status de Comissão */}
          <Header as="h5" dividing style={{ color: '#444', marginBottom: '0.8rem' }}>
            <Icon name="tasks" />
            Status de Comissão
          </Header>
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', marginBottom: '0.5rem' }}>
            {Object.keys(excelStatusComissao).map((status) => {
              const isPago = status === 'Pago';
              const cor = excelStatusComissao[status]
                ? (isPago ? '#2185d0' : '#21ba45')
                : '#ccc';
              const bgAtivo = isPago ? '#f0f8ff' : '#f0fff4';
              return (
                <div
                  key={status}
                  onClick={() => setExcelStatusComissao(prev => ({ ...prev, [status]: !prev[status] }))}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '0.5rem',
                    cursor: 'pointer', userSelect: 'none',
                    padding: '0.5rem 1rem',
                    borderRadius: '8px',
                    border: `2px solid ${cor}`,
                    background: excelStatusComissao[status] ? bgAtivo : '#fafafa',
                    transition: 'all 0.15s',
                    fontWeight: excelStatusComissao[status] ? '600' : '400',
                    color: excelStatusComissao[status] ? cor : '#888',
                    position: 'relative',
                  }}
                >
                  <Icon
                    name={excelStatusComissao[status] ? 'check square' : 'square outline'}
                    style={{ margin: 0, color: cor }}
                  />
                  {status}
                </div>
              );
            })}
          </div>
          <p style={{ fontSize: '0.82rem', color: '#999', marginTop: '0.8rem' }}>
            <Icon name="info circle" /> "Pago" vem desmarcado por padrão pois representa comissões já liquidadas.
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button
            basic
            color="grey"
            onClick={() => {
              setExcelStatusFatura({ Quitada: true, 'A Vencer': true, Vencida: true });
              setExcelStatusComissao({ Pendente: true, 'Em Aberto': true, 'Parcialmente Pago': true, Aprovada: true, Rejeitada: true, Pago: false });
            }}
          >
            <Icon name="redo" /> Restaurar Padrões
          </Button>
          <Button color="grey" onClick={() => setOpenModalExcel(false)}>
            Cancelar
          </Button>
          <Button
            color="green"
            icon
            labelPosition="left"
            onClick={() => executarExportarExcel()}
          >
            <Icon name="download" />
            Exportar
          </Button>
        </Modal.Actions>
      </Modal>
      {/* ===== FIM MODAL EXPORTAR EXCEL ===== */}
      <Container fluid style={{ padding: "0" }}>
        <Header as="h2" textAlign="center" color="grey" className="page-header">
          Consulta de Vendas Agenciadas
        </Header>
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between" }}>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <Button 
              color={menuFiltro ? "blue" : "grey"}
              basic={!menuFiltro}
              onClick={() => setMenuFiltro(!menuFiltro)}
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <Icon name="filter" style={{ margin: 0 }} />
              Filtros
              <Icon name={menuFiltro ? "chevron up" : "chevron down"} style={{ margin: 0 }} />
            </Button>
            <Button
              icon
              labelPosition="left"
              color="red"
              disabled={!habilitarPdf || !listaFaturas || listaFaturas.length === 0}
              title="Clique aqui para gerar um relatório no formato PDF"
              style={{ marginLeft: "1rem" }}
              onClick={() => setOpenModalPdf(true)}
            >
              <Icon name="file pdf" />
              Gerar PDF
            </Button>
            <Button 
              icon
              labelPosition="left"
              color="green" 
              disabled={!habilitarPdf || !listaFaturas || listaFaturas.length === 0} 
              title="Exportar relatório em Excel" 
              style={{ marginLeft: "0.5rem" }} 
              onClick={() => abrirModalExportarExcel()} 
            >
              <Icon name="file excel" />
              Exportar Excel
            </Button>
          </div>
        </div>
        {menuFiltro && (
          <Segment attached="bottom" className="filtro filtro-header" style={{ zIndex: (openModal || openModalExcel || openModalPdf || confirmacaoVolume.open) ? "900" : "1002" }}>
            {/* <Header as='h2' textAlign="left" color="grey" className="filtro-header" >Filtros</Header> */}
            <Form size="tiny" className="form-filtros">
              <Message info size="tiny" icon style={{ marginTop: 0 }}>
                <Icon name="info circle" />
                <Message.Content>
                  Informe o período completo ou pelo menos um destes filtros: Número da Nota, RCA ou Agenciador. Em “Todo o Período”, informe Nota, RCA ou Agenciador.
                </Message.Content>
              </Message>
              <Form.Group style={{ position: 'relative', zIndex: 110 }}>
                <Form.Select
                  fluid
                  search
                  multiple
                  selection
                  clearable
                  label="Filial"
                  disabled={false}
                  placeholder="Filtrar por Filial"
                  options={listaFiliais}
                  value={filtroFilial}
                  onChange={(e, { value }) => setFiltroFilial(value)}
                  width={5}
                />
                <Form.Select
                  fluid
                  search
                  multiple
                  selection
                  clearable
                  label="RCA"
                  disabled={false}
                  placeholder="Filtrar por RCA"
                  options={listaRCA}
                  value={filtroRca}
                  onChange={(e, { value }) => setFiltroRca(value)}
                  width={5}
                />
                <Form.Select
                  fluid
                  search
                  multiple
                  selection
                  clearable
                  label="Agenciador"
                  placeholder="Filtrar por Agenciador"
                  disabled={false}
                  options={listaAgenciadores}
                  value={filtroAgenciador}
                  onChange={(e, { value }) => setFiltroAgenciador(value)}
                  width={6}
                />
              </Form.Group>
              <Form.Group style={{ position: 'relative', zIndex: 109 }}>
                <Form.Input
                  fluid
                  label="Nº Nota"
                  placeholder="Filtrar por Nº Nota"
                  disabled={false}
                  value={filtroNota}
                  onChange={(e, { value }) => setFiltroNota(value)}
                  width={3}
                />
                <Form.Input
                  fluid
                  label="Transação"
                  placeholder="Filtrar por Transação"
                  disabled={false}
                  value={filtroTransacao}
                  onChange={(e, { value }) => setFiltroTransacao(value)}
                  width={3}
                />
                <Form.Field style={{ paddingRight: '15px' }} width={4}>
                  <label>Exibir Status</label>
                  <div style={{display: 'flex', gap: '20px', paddingTop: '5px', alignItems: 'center'}}>
                    <Form.Checkbox label="Quitadas" checked={checkPaga} onChange={(e, {checked}) => setCheckPaga(checked)} />
                    <Form.Checkbox label="A Vencer" checked={checkAVencer} onChange={(e, {checked}) => setCheckAVencer(checked)} />
                    <Form.Checkbox label="Vencidas" checked={checkVencida} onChange={(e, {checked}) => setCheckVencida(checked)} />
                  </div>
                </Form.Field>

                <Form.Field style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap', gap: '24px', paddingBottom: '7px' }} width={6}>
                  <Form.Checkbox 
                    label="Todo o Período" 
                    checked={todoPeriodo} 
                    onChange={(e, { checked }) => {
                      setTodoPeriodo(checked);
                      if (checked) {
                        setFiltroEmissaoInicial(null);
                        setFiltroEmissaoFinal(null);
                        setTextoAtalhoPeriodo('Atalhos de Período');
                      }
                    }}
                    toggle 
                  />
                  <Form.Checkbox
                    label={`Ocultar comissões negativas${quantidadeComissoesNegativas > 0 ? ` (${quantidadeComissoesNegativas})` : ""}`}
                    checked={ocultarComissoesNegativas}
                    onChange={(e, { checked }) => alterarVisibilidadeComissoesNegativas(checked)}
                    title="Oculta apenas nesta consulta os registros cuja comissão bruta é negativa"
                    toggle
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group style={{ position: 'relative', zIndex: 108 }}>
                <Form.Field className="datepicker-field" disabled={todoPeriodo} width={3}>
                  <label>Data Emissão Inicial</label>
                  <div className="datepicker-input">
                    <SemanticDatepicker
                      locale="pt-BR"
                      disabled={todoPeriodo}
                      format="DD/MM/YYYY"
                      value={filtroEmissaoInicial}
                      onChange={(e, { value }) => { 
                        setFiltroEmissaoInicial(value);
                        if (e && e.type) setTextoAtalhoPeriodo('Atalhos de Período'); 
                      }}
                    />
                  </div>
                </Form.Field>
                <Form.Field className="datepicker-field" disabled={todoPeriodo} width={3}>
                  <label>Data Emissão Final</label>
                  <div className="datepicker-input">
                    <SemanticDatepicker
                      locale="pt-BR"
                      disabled={todoPeriodo}
                      format="DD/MM/YYYY"
                      value={filtroEmissaoFinal}
                      onChange={(e, { value }) => { 
                        setFiltroEmissaoFinal(value);
                        if (e && e.type) setTextoAtalhoPeriodo('Atalhos de Período'); 
                      }}
                    />
                  </div>
                </Form.Field>
                <Form.Field width={3}>
                  <label>&nbsp;</label>
                  <Dropdown text={textoAtalhoPeriodo} button className='icon' disabled={todoPeriodo} fluid>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => aplicarPeriodoRapido('hoje')} text='Hoje' />
                      <Dropdown.Item onClick={() => aplicarPeriodoRapido('semana')} text='Esta Semana' />
                      <Dropdown.Item onClick={() => aplicarPeriodoRapido('mes')} text='Este Mês' />
                      <Dropdown.Item onClick={() => aplicarPeriodoRapido('mes_passado')} text='Mês Passado' />
                      <Dropdown.Item onClick={() => aplicarPeriodoRapido('3_meses')} text='Últimos 3 Meses' />
                      <Dropdown.Item onClick={() => aplicarPeriodoRapido('6_meses')} text='Últimos 6 Meses' />
                      <Dropdown.Item onClick={() => aplicarPeriodoRapido('1_ano')} text='Último 1 Ano' />
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Field>
                <Form.Field width={3}>
                  <label>&nbsp;</label>
                  <Button color="blue" icon="search" content="Pesquisar" disabled={loadingTable} onClick={filtrarComissoes} fluid />
                </Form.Field>
              </Form.Group>
              <Form.Group style={{ position: 'relative', zIndex: 107 }}>
                <Form.Select
                  fluid
                  search
                  label="Pg Com"
                  placeholder="Filtrar por Pg Com"
                  disabled={false}
                  options={selectPgCom}
                  value={filtroPgCom}
                  onChange={(e, { value }) => setFiltroPgCom(value)}
                  width={4}
                />
                <Form.Select
                  fluid
                  search
                  label="Status da Aprovação"
                  placeholder="Filtrar por Status da Aprovação"
                  disabled={false}
                  options={selectStatusApro}
                  value={filtroStatusAprovacao}
                  onChange={(e, { value }) => setFiltroStatusAprovacao(value)}
                  width={4}
                />
                <Form.Select
                  fluid
                  search
                  label="Aprovado Por"
                  placeholder="Filtrar por quem aprovou a comissão"
                  disabled={false}
                  options={listaAprovadores}
                  value={filtroAprovadoPor}
                  onChange={(e, { value }) => setFiltroAprovadoPor(value)}
                  width={4}
                />
                <Button
                  style={{ alignSelf: "end", marginLeft: ".2rem", padding: "10px 15px" }}
                  type="button"
                  color="grey"
                  basic
                  icon="eraser"
                  content="Limpar Todos os Filtros"
                  title="Clique aqui para limpar os campos de filtragem"
                  onClick={() => resetarFiltros()}
                />
              </Form.Group>
            </Form>
          </Segment>
        )}
      <style>{`

        .modern-blue-modal {
          background: linear-gradient(135deg, #0d71bb 0%, #00b5ad 100%);
          border-radius: 20px;
          padding: 40px 60px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.2);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: white;
        }
        .consulta-table-wrapper {
          position: relative;
          margin-bottom: 2rem;
          padding-bottom: 15px;
        }
        .consulta-table-wrapper .ui.attached.header {
          position: sticky !important;
          top: 0;
          left: 0;
          width: 100%;
          max-width: 100%;
          z-index: 1000;
        }
        .consulta-table-wrapper table {
          margin-top: 0 !important;
        }
        .consulta-table-wrapper table thead th {
          position: sticky !important;
          top: 0 !important;
          z-index: 999;
          background-color: #f9fafb !important;
          box-shadow: 0 1px 2px rgba(0,0,0,0.1);
        }
      `}</style>
      <Dimmer active={loadingTable} page style={{backgroundColor: "rgba(0, 0, 0, 0.6)", backdropFilter: "blur(5px)", zIndex: 999999}}>
        <div className="modern-blue-modal">
           <Icon name="circle notch" loading size="huge" style={{marginBottom: '15px'}} />
           <Header as="h2" style={{color: 'white', marginTop: '0', fontWeight: '600', letterSpacing: '1px'}}>
              Buscando informações
           </Header>
           <p style={{color: 'rgba(255,255,255,0.85)', fontSize: '1.1rem', margin: '0'}}>
              {progressoLoading === 100 
                ? "Finalizando o processamento... (100%)" 
                : progressoLoading >= 99 
                  ? "Por favor, aguarde, finalizando o processamento... (99%)"
                  : `Por favor, aguarde enquanto buscamos os dados... (${progressoLoading}%)`}
           </p>
        </div>
      </Dimmer>
      <div className="content-wrapper">
        {statusConsulta === "success" && listaFaturas.length === 0 && listaFaturasIncluindoNegativas.length > 0 && !loadingTable && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
            <Message info icon size="massive" style={{ textAlign: 'center', maxWidth: '800px' }}>
              <Icon name='eye slash' />
              <Message.Content>
                <Message.Header style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Lançamentos negativos ocultados</Message.Header>
                <p style={{ fontSize: '1.2rem' }}>Todos os resultados encontrados possuem comissão bruta negativa. Desative “Ocultar comissões negativas” para visualizá-los.</p>
              </Message.Content>
            </Message>
          </div>
        )}
        {statusConsulta === "success" && listaFaturas.length === 0 && listaFaturasIncluindoNegativas.length === 0 && !loadingTable && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
            <Message warning icon size="massive" style={{ textAlign: 'center', maxWidth: '800px' }}>
              <Icon name='search' />
              <Message.Content>
                <Message.Header style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Nenhuma informação encontrada</Message.Header>
                <p style={{ fontSize: '1.2rem' }}>Não existem vendas agenciadas para os filtros informados.</p>
              </Message.Content>
            </Message>
          </div>
        )}
          <Segment basic style={{ padding: "0 1px", display: listaFaturas.length === 0 ? "none" : "block" }}>
            {checkPaga && (
              <div className="consulta-table-wrapper">
            <div className="modern-status-header status-quitadas" style={{ marginTop: '20px', cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }} onClick={() => setCollapseQuitadas(!collapseQuitadas)}>
              <span style={{flex: 1, textAlign: 'center', fontWeight: 'bold', fontSize: '1.2rem'}}>Faturas Quitadas</span>
              <Icon name={collapseQuitadas ? "angle down" : "angle up"} size="large" />
            </div>
            {!collapseQuitadas && (
              <div className="consulta-table-scroll">
              <Table className="consulta-comissoes-table" color="blue" sortable celled size="small" selectable style={{ marginTop: 0, borderTopLeftRadius: 0, borderTopRightRadius: 0, borderTop: "none" }}>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell title="RCA" width={2}>
                    RCA
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Agenciador" width={4}>
                    Agenciador
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Consumidor Final" width={3}>
                    Consumidor Final
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Nº NF-Parcela" width={3}>
                    Nº NF-Parcela
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Forma Pagamento" width={3}>
                    Forma Pagamento
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Emissão" width={3}>
                    Emissão
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Vencimento" width={3}>
                    Vencimento
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Valor Bruto" width={2}>
                    Valor Bruto
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Vl. Compra/Boleto" width={2}>
                    Vl. Compra/Boleto
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Vl. Pagamento" width={2}>
                    Vl. Pagamento
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Valor a Pagar" width={2}>
                    Valor a Pagar
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Status" width={3}>
                    Status
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {listaFaturas.map((fatura) => (
                  <>
                    {fatura.statusFatura === "Quitada" && (
                      <Table.Row key={fatura.numeroTransacaoVenda + fatura.prestacao} style={{ cursor: "pointer" }} onClick={() => abrirModalFatura(fatura)}>
                        <Table.Cell title={fatura.idRCA}>{fatura.idRCA}</Table.Cell>
                        <Table.Cell title={fatura.nomeAgenciador}>{fatura.nomeAgenciador}</Table.Cell>
                        <Table.Cell title={fatura.nomeCliente}>{fatura.nomeCliente}</Table.Cell>
                        <Table.Cell title={fatura.numeroNota + " - " + fatura.prestacao}>{fatura.numeroNota + " - " + fatura.prestacao}</Table.Cell>
                        <Table.Cell title={fatura.tipoCobranca}>{fatura.tipoCobranca}</Table.Cell>
                        <Table.Cell title={Util.exibirDataFormatada(fatura.dataEmissao)}>{Util.exibirDataFormatada(fatura.dataEmissao)}</Table.Cell>
                        <Table.Cell title={Util.exibirDataFormatada(fatura.dataVencimento)}>{Util.exibirDataFormatada(fatura.dataVencimento)}</Table.Cell>
                        <Table.Cell textAlign="right" title={Util.exibirValorMonetarioBr(fatura.valorComissaoBruta)}>
                          {Util.exibirValorMonetarioBr(fatura.valorComissaoBruta)}
                        </Table.Cell>
                        <Table.Cell textAlign="right" title={Util.exibirValorMonetarioBr(fatura.valorComissaoNfeRepresentacoes)}>
                          {Util.exibirValorMonetarioBr(fatura.valorComissaoNfeRepresentacoes)}
                        </Table.Cell>
                        <Table.Cell textAlign="right" title={Util.exibirValorMonetarioBr(fatura.valorComissaoNfe)}>
                          {Util.exibirValorMonetarioBr(fatura.valorComissaoNfe)}
                        </Table.Cell>
                        <Table.Cell textAlign="right" title={Util.exibirValorMonetarioBr(fatura.valorAPagar)}>
                          <Dimmer.Dimmable dimmed={!fatura.terminouLoading}>
                            <Dimmer active={!fatura.terminouLoading} inverted>
                              <Loader active={!fatura.terminouLoading} />
                            </Dimmer>
                            {fatura.terminouLoading ? (
                              <>{fatura.valorAPagar || fatura.valorAPagar === 0 ? Util.exibirValorMonetarioBr(fatura.valorAPagar) : ""}</>
                            ) : (
                              <span>Carregando</span>
                            )}
                          </Dimmer.Dimmable>
                        </Table.Cell>
                        <Table.Cell textAlign="left" title={fatura.statusComissao || obterStatusComissao(fatura)}>
                          <Dimmer.Dimmable dimmed={!fatura.terminouLoading}>
                            <Dimmer active={!fatura.terminouLoading} inverted>
                              <Loader active={!fatura.terminouLoading} />
                            </Dimmer>
                            {fatura.terminouLoading ? <>{fatura.statusComissao || obterStatusComissao(fatura)}</> : <span>Carregando</span>}
                          </Dimmer.Dimmable>
                        </Table.Cell>
                      </Table.Row>
                    )}
                  </>
                ))}
                <Table.Row>
                  <TableCell style={{ fontSize: "1rem" }} textAlign="right" colSpan={7}>
                    <b>Total:</b>
                  </TableCell>
                  <TableCell style={{ fontSize: "1rem", fontWeight:"bold" }} textAlign="right">
                    {Util.exibirValorMonetarioBr(totalBrutaQuitadas)}
                  </TableCell>
                  <TableCell style={{ fontSize: "1rem", fontWeight:"bold" }} textAlign="right">
                    {Util.exibirValorMonetarioBr(totalCompraBoletoQuitadas)}
                  </TableCell>
                  <TableCell style={{ fontSize: "1rem", fontWeight:"bold" }} textAlign="right">
                    {Util.exibirValorMonetarioBr(totalPagamentoQuitadas)}
                  </TableCell>
                  <TableCell style={{ fontSize: "1rem" }} textAlign="right">
                    <Dimmer.Dimmable dimmed={!habilitarPdf}>
                      <Dimmer active={!habilitarPdf} inverted>
                        <Loader active={!habilitarPdf} />
                      </Dimmer>
                      {habilitarPdf ? <>{Util.exibirValorMonetarioBr(totalQuitadas)}</> : <span>Carregando</span>}
                    </Dimmer.Dimmable>
                  </TableCell>
                  <TableCell colSpan={1}></TableCell>
                </Table.Row>
              </Table.Body>
            </Table>
            </div>
            )}
              </div>
            )}
            {checkAVencer && (
              <div className="consulta-table-wrapper">
            <div className="modern-status-header status-avencer" style={{ marginTop: '20px', cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }} onClick={() => setCollapseAVencer(!collapseAVencer)}>
              <span style={{flex: 1, textAlign: 'center', fontWeight: 'bold', fontSize: '1.2rem'}}>Faturas a Vencer</span>
              <Icon name={collapseAVencer ? "angle down" : "angle up"} size="large" />
            </div>
            {!collapseAVencer && (
              <div className="consulta-table-scroll">
              <Table className="consulta-comissoes-table" color="blue" sortable celled size="small" selectable style={{ marginTop: 0, borderTopLeftRadius: 0, borderTopRightRadius: 0, borderTop: "none" }}>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell title="RCA" width={2}>
                    RCA
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Agenciador" width={4}>
                    Agenciador
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Consumidor Final" width={3}>
                    Consumidor Final
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Nº NF-Parcela" width={3}>
                    Nº NF-Parcela
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Forma Pagamento" width={3}>
                    Forma Pagamento
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Emissão" width={3}>
                    Emissão
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Vencimento" width={3}>
                    Vencimento
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Valor Bruto" width={2}>
                    Valor Bruto
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Vl. Compra/Boleto" width={2}>
                    Vl. Compra/Boleto
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Vl. Pagamento" width={2}>
                    Vl. Pagamento
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Valor a Pagar" width={2}>
                    Valor a Pagar
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Status" width={3}>
                    Status
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {listaFaturas.map((fatura) => (
                  <>
                    {fatura.statusFatura === "A Vencer" && (
                      <Table.Row key={fatura.numeroTransacaoVenda + fatura.prestacao} style={{ cursor: "pointer" }} onClick={() => abrirModalFatura(fatura)}>
                        <Table.Cell title={fatura.idRCA}>{fatura.idRCA}</Table.Cell>
                        <Table.Cell title={fatura.nomeAgenciador}>{fatura.nomeAgenciador}</Table.Cell>
                        <Table.Cell title={fatura.nomeCliente}>{fatura.nomeCliente}</Table.Cell>
                        <Table.Cell title={fatura.numeroNota + " - " + fatura.prestacao}>{fatura.numeroNota + " - " + fatura.prestacao}</Table.Cell>
                        <Table.Cell title={fatura.tipoCobranca}>{fatura.tipoCobranca}</Table.Cell>
                        <Table.Cell title={Util.exibirDataFormatada(fatura.dataEmissao)}>{Util.exibirDataFormatada(fatura.dataEmissao)}</Table.Cell>
                        <Table.Cell title={Util.exibirDataFormatada(fatura.dataVencimento)}>{Util.exibirDataFormatada(fatura.dataVencimento)}</Table.Cell>
                        <Table.Cell textAlign="right" title={Util.exibirValorMonetarioBr(fatura.valorComissaoBruta)}>
                          {Util.exibirValorMonetarioBr(fatura.valorComissaoBruta)}
                        </Table.Cell>
                        <Table.Cell textAlign="right" title={Util.exibirValorMonetarioBr(fatura.valorComissaoNfeRepresentacoes)}>
                          {Util.exibirValorMonetarioBr(fatura.valorComissaoNfeRepresentacoes)}
                        </Table.Cell>
                        <Table.Cell textAlign="right" title={Util.exibirValorMonetarioBr(fatura.valorComissaoNfe)}>
                          {Util.exibirValorMonetarioBr(fatura.valorComissaoNfe)}
                        </Table.Cell>
                        <Table.Cell textAlign="right" title={Util.exibirValorMonetarioBr(fatura.valorAPagar)}>
                          <Dimmer.Dimmable dimmed={!fatura.terminouLoading}>
                            <Dimmer active={!fatura.terminouLoading} inverted>
                              <Loader active={!fatura.terminouLoading} />
                            </Dimmer>
                            {fatura.terminouLoading ? (
                              <>{fatura.valorAPagar || fatura.valorAPagar === 0 ? Util.exibirValorMonetarioBr(fatura.valorAPagar) : ""}</>
                            ) : (
                              <span>Carregando</span>
                            )}
                          </Dimmer.Dimmable>
                        </Table.Cell>
                        <Table.Cell textAlign="left" title={fatura.statusComissao || obterStatusComissao(fatura)}>
                          <Dimmer.Dimmable dimmed={!fatura.terminouLoading}>
                            <Dimmer active={!fatura.terminouLoading} inverted>
                              <Loader active={!fatura.terminouLoading} />
                            </Dimmer>
                            {fatura.terminouLoading ? <>{fatura.statusComissao || obterStatusComissao(fatura)}</> : <span>Carregando</span>}
                          </Dimmer.Dimmable>
                        </Table.Cell>
                      </Table.Row>
                    )}
                  </>
                ))}
                <Table.Row>
                  <TableCell style={{ fontSize: "1rem" }} textAlign="right" colSpan={7}>
                    <b>Total:</b>
                  </TableCell>
                  <TableCell style={{ fontSize: "1rem", fontWeight:"bold" }} textAlign="right">
                    {Util.exibirValorMonetarioBr(totalBrutaAVencer)}
                  </TableCell>
                  <TableCell style={{ fontSize: "1rem", fontWeight:"bold" }} textAlign="right">
                    {Util.exibirValorMonetarioBr(totalCompraBoletoAVencer)}
                  </TableCell>
                  <TableCell style={{ fontSize: "1rem", fontWeight:"bold" }} textAlign="right">
                    {Util.exibirValorMonetarioBr(totalPagamentoAVencer)}
                  </TableCell>
                  <TableCell style={{ fontSize: "1rem" }} textAlign="right">
                    <Dimmer.Dimmable dimmed={!habilitarPdf}>
                      <Dimmer active={!habilitarPdf} inverted>
                        <Loader active={!habilitarPdf} />
                      </Dimmer>
                      {habilitarPdf ? <>{Util.exibirValorMonetarioBr(totalAVencer)}</> : <span>Carregando</span>}
                    </Dimmer.Dimmable>
                  </TableCell>
                  <TableCell colSpan={1}></TableCell>
                </Table.Row>
              </Table.Body>
            </Table>
            </div>
            )}
              </div>
            )}
            {checkVencida && (
              <div className="consulta-table-wrapper">
            <div className="modern-status-header status-vencidas" style={{ marginTop: '20px', cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }} onClick={() => setCollapseVencidas(!collapseVencidas)}>
              <span style={{flex: 1, textAlign: 'center', fontWeight: 'bold', fontSize: '1.2rem'}}>Faturas em Aberto (Vencidas)</span>
              <Icon name={collapseVencidas ? "angle down" : "angle up"} size="large" />
            </div>
            {!collapseVencidas && (
              <div className="consulta-table-scroll">
              <Table className="consulta-comissoes-table" color="blue" sortable celled size="small" selectable style={{ marginTop: 0, borderTopLeftRadius: 0, borderTopRightRadius: 0, borderTop: "none" }}>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell title="RCA" width={2}>
                    RCA
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Agenciador" width={4}>
                    Agenciador
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Consumidor Final" width={3}>
                    Consumidor Final
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Nº NF-Parcela" width={3}>
                    Nº NF-Parcela
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Forma Pagamento" width={3}>
                    Forma Pagamento
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Emissão" width={3}>
                    Emissão
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Vencimento" width={3}>
                    Vencimento
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Valor Bruto" width={2}>
                    Valor Bruto
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Vl. Compra/Boleto" width={2}>
                    Vl. Compra/Boleto
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Vl. Pagamento" width={2}>
                    Vl. Pagamento
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Valor a Pagar" width={2}>
                    Valor a Pagar
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Status" width={3}>
                    Status
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {listaFaturas.map((fatura) => (
                  <>
                    {fatura.statusFatura === "Vencida" && (
                      <Table.Row key={fatura.numeroTransacaoVenda + fatura.prestacao} style={{ cursor: "pointer" }} onClick={() => abrirModalFatura(fatura)}>
                        <Table.Cell title={fatura.idRCA}>{fatura.idRCA}</Table.Cell>
                        <Table.Cell title={fatura.nomeAgenciador}>{fatura.nomeAgenciador}</Table.Cell>
                        <Table.Cell title={fatura.nomeCliente}>{fatura.nomeCliente}</Table.Cell>
                        <Table.Cell title={fatura.numeroNota + " - " + fatura.prestacao}>{fatura.numeroNota + " - " + fatura.prestacao}</Table.Cell>
                        <Table.Cell title={fatura.tipoCobranca}>{fatura.tipoCobranca}</Table.Cell>
                        <Table.Cell title={Util.exibirDataFormatada(fatura.dataEmissao)}>{Util.exibirDataFormatada(fatura.dataEmissao)}</Table.Cell>
                        <Table.Cell title={Util.exibirDataFormatada(fatura.dataVencimento)}>{Util.exibirDataFormatada(fatura.dataVencimento)}</Table.Cell>
                        <Table.Cell textAlign="right" title={Util.exibirValorMonetarioBr(fatura.valorComissaoBruta)}>
                          {Util.exibirValorMonetarioBr(fatura.valorComissaoBruta)}
                        </Table.Cell>
                        <Table.Cell textAlign="right" title={Util.exibirValorMonetarioBr(fatura.valorComissaoNfeRepresentacoes)}>
                          {Util.exibirValorMonetarioBr(fatura.valorComissaoNfeRepresentacoes)}
                        </Table.Cell>
                        <Table.Cell textAlign="right" title={Util.exibirValorMonetarioBr(fatura.valorComissaoNfe)}>
                          {Util.exibirValorMonetarioBr(fatura.valorComissaoNfe)}
                        </Table.Cell>
                        <Table.Cell textAlign="right" title={Util.exibirValorMonetarioBr(fatura.valorAPagar)}>
                          <Dimmer.Dimmable dimmed={!fatura.terminouLoading}>
                            <Dimmer active={!fatura.terminouLoading} inverted>
                              <Loader active={!fatura.terminouLoading} />
                            </Dimmer>
                            {fatura.terminouLoading ? (
                              <>{fatura.valorAPagar || fatura.valorAPagar === 0 ? Util.exibirValorMonetarioBr(fatura.valorAPagar) : ""}</>
                            ) : (
                              <span>Carregando</span>
                            )}
                          </Dimmer.Dimmable>
                        </Table.Cell>
                        <Table.Cell textAlign="left" title={fatura.statusComissao || obterStatusComissao(fatura)}>
                          <Dimmer.Dimmable dimmed={!fatura.terminouLoading}>
                            <Dimmer active={!fatura.terminouLoading} inverted>
                              <Loader active={!fatura.terminouLoading} />
                            </Dimmer>
                            {fatura.terminouLoading ? <>{fatura.statusComissao || obterStatusComissao(fatura)}</> : <span>Carregando</span>}
                          </Dimmer.Dimmable>
                        </Table.Cell>
                      </Table.Row>
                    )}
                  </>
                ))}
                <Table.Row>
                  <TableCell style={{ fontSize: "1rem" }} textAlign="right" colSpan={7}>
                    <b>Total:</b>
                  </TableCell>
                  <TableCell style={{ fontSize: "1rem", fontWeight:"bold" }} textAlign="right">
                    {Util.exibirValorMonetarioBr(totalBrutaVencidas)}
                  </TableCell>
                  <TableCell style={{ fontSize: "1rem", fontWeight:"bold" }} textAlign="right">
                    {Util.exibirValorMonetarioBr(totalCompraBoletoVencidas)}
                  </TableCell>
                  <TableCell style={{ fontSize: "1rem", fontWeight:"bold" }} textAlign="right">
                    {Util.exibirValorMonetarioBr(totalPagamentoVencidas)}
                  </TableCell>
                  <TableCell style={{ fontSize: "1rem" }} textAlign="right">
                    <Dimmer.Dimmable dimmed={!habilitarPdf}>
                      <Dimmer active={!habilitarPdf} inverted>
                        <Loader active={!habilitarPdf} />
                      </Dimmer>
                      {habilitarPdf ? <>{Util.exibirValorMonetarioBr(totalVencidas)}</> : <span>Carregando</span>}
                    </Dimmer.Dimmable>
                  </TableCell>
                  <TableCell colSpan={1}></TableCell>
                </Table.Row>
              </Table.Body>
            </Table>
            </div>
            )}
              </div>
            )}
          </Segment>
        </div>
      </Container>
      <Modal closeIcon centered size={"large"} open={openModal} onClose={() => fecharModalFatura(false)}>
        {faturaModal && (
          <Modal.Content>
            <Dimmer.Dimmable dimmed={loadingModal}>
              <Dimmer active={loadingModal} inverted>
                <Loader active={loadingModal} />
              </Dimmer>
              <Segment basic style={{ padding: "2px" }}>
                <Card fluid color="blue" style={{ transition: "none", transform: "none" }}>
                  <Card.Content style={{ display: "flex", justifyContent: "space-between" }}>
                    <Card.Header>Agenciador: {faturaModal.nomeAgenciador}</Card.Header>
                    {faturaModal.statusFatura === "Quitada" && <Card.Header style={{ color: "limegreen" }}>{faturaModal.statusFatura}</Card.Header>}
                    {faturaModal.statusFatura === "A Vencer" && <Card.Header style={{ color: "darkorange" }}>{faturaModal.statusFatura}</Card.Header>}
                    {faturaModal.statusFatura === "Vencida" && <Card.Header style={{ color: "orangered" }}>{faturaModal.statusFatura}</Card.Header>}
                  </Card.Content>
                  <Card.Content>
                    <div style={{ display: "flex", flexDirection: "column", gap: ".5rem" }}>
                      <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", marginBottom: ".5rem", justifyContent: "space-between" }}>
                        <div className="fatura__card__column" style={{ display: "flex", flexDirection: "column" }}>
                          <span>
                            <b>Cliente: &nbsp; {faturaModal.nomeCliente}</b>
                          </span>
                          <span>Emissão: &nbsp; {Util.exibirDataFormatada(faturaModal.dataEmissao)}</span>
                          <span>Quitação: &nbsp; {Util.exibirDataFormatada(faturaModal.dataQuitacao)}</span>
                          <span>Vencimento: &nbsp; {Util.exibirDataFormatada(faturaModal.dataVencimento)}</span>
                          <span>
                            Transação: <b>{faturaModal.numeroTransacaoVenda + "-" + faturaModal.prestacao}</b>
                          </span>
                          <span>
                            Região do pedido: &nbsp; <b>{faturaModal.regiaoPedido}</b>{" "}
                          </span>
                        </div>
                        <div className="fatura__card__column" style={{ display: "flex", flexDirection: "column" }}>
                          <span>
                            Cobrança: &nbsp; <b>{faturaModal.tipoCobranca}</b>
                          </span>
                          <span>Cod. Profissional: &nbsp; {faturaModal.codigoProfissional}</span>
                          <span>Cod. Vendedor: &nbsp; {faturaModal.idRCA}</span>
                          <span>Dt. Devol: &nbsp; {Util.exibirDataFormatada(faturaModal.dataDevolucao)}</span>
                          <span>Vl. Devol: &nbsp; {faturaModal.dataDevolucao ? Util.exibirValorMonetarioBr(faturaModal.valorDevolvido) : ""}</span>
                        </div>
                        <div className="fatura__card__column" style={{ display: "flex", flexDirection: "column" }}>
                          <span>Vl. Vendido: &nbsp; {Util.exibirValorMonetarioBr(faturaModal.valorVenvido)}</span>
                          <span>Vl. Tabela PSD: &nbsp; {Util.exibirValorMonetarioBr(faturaModal.valorTabelaPSD)}</span>
                          <span>Percentual: &nbsp; {faturaModal.percentual + "%"}</span>
                          <span>Nota: &nbsp; {faturaModal.numeroNota}</span>
                          <span>Parcela: &nbsp; {faturaModal.prestacao}</span>
                          <span>Vl. Parcela: &nbsp; {Util.exibirValorMonetarioBr(faturaModal.valorParcela)}</span>
                        </div>
                        <div className="fatura__card__column fatura_card_column--radio" style={{ display: "flex", flexDirection: "column" }}>
                          {faturaModal.rejeitada === true ? (
                            <span style={{ fontWeight: "bold" }}>
                              Status da aprovação: &nbsp; <b style={{ color: "red" }}>{"Rejeitada"}</b>
                            </span>
                          ) : (
                            <span style={{ fontWeight: "bold" }}>
                              Status da aprovação: &nbsp; <b style={{ color: faturaModal.aprovacao ? "royalblue" : "gold" }}>{faturaModal.aprovacao ? "Aprovada" : "Pendente"}</b>
                            </span>
                          )}
                          {faturaModal.rejeitada === true && <span style={{ fontWeight: "bold" }}>Motivo rejeição: &nbsp; {faturaModal.motivoRejeicao}</span>}
                          <span>
                            <b>Pg. Com.: &nbsp; {faturaModal.statusPagamentoComissao}</b>
                          </span>
                          <span>
                            <b>Dt. Encerramento Com.: &nbsp; {Util.exibirDataFormatada(faturaModal.dataEncerramentoComercial)}</b>
                          </span>
                          <span>
                            <b>Vl. A Pagar: &nbsp; {faturaModal.valorAPagar || faturaModal.valorAPagar === 0 ? Util.exibirValorMonetarioBr(faturaModal.valorAPagar) : ""}</b>
                          </span>
                          {faturaModal.statusDesdobramento && (
                            <span style={{ fontWeight: "bold" }}>
                              Status Desdobramento: &nbsp;<b style={{ color: "red" }}> {faturaModal.statusDesdobramento}</b>
                            </span>
                          )}
                          {faturaModal.aprovacao === true && (
                            <>
                              <span>
                                <b>Tipo Comissão: &nbsp; {faturaModal.tipoComissao ? faturaModal.tipoComissao.replace(/_/g, " ").replace("c", "C") : ""}</b>
                              </span>
                              <span>
                                <b>Vl. Comissão: &nbsp; {Util.exibirValorMonetarioBr(faturaModal.valorComissaoSelecionada)}</b>
                              </span>
                              <br />
                              {faturaModal.tipoComissao !== "comissao_bruta" && (
                                <span style={{ opacity: ".45" }}>
                                  <b>Comissão bruta: &nbsp; {Util.exibirValorMonetarioBr(faturaModal.valorComissaoBruta)}</b>
                                </span>
                              )}
                              {faturaModal.tipoComissao !== "comissao_nfe_solar" && (
                                <span style={{ opacity: ".45" }}>
                                  <b>Comissão nfe solar: &nbsp; {Util.exibirValorMonetarioBr(faturaModal.valorComissaoNfeSolar)}</b>
                                </span>
                              )}
                              {faturaModal.tipoComissao !== "comissao_nfe_representacoes" && (
                                <span style={{ opacity: ".45" }}>
                                  <b>Comissão nfe representacoes: &nbsp; {Util.exibirValorMonetarioBr(faturaModal.valorComissaoNfeRepresentacoes)}</b>
                                </span>
                              )}

                              {faturaModal.tipoComissao !== "comissao_com_nfe" && (
                                <span style={{ opacity: ".45" }}>
                                  <b>Comissão com nfe: &nbsp; {Util.exibirValorMonetarioBr(faturaModal.valorComissaoNfe)}</b>
                                </span>
                              )}
                              {faturaModal.tipoComissao !== "comissao_sem_nfe" && (
                                <span style={{ opacity: ".45" }}>
                                  <b>Comissão sem nfe: &nbsp; {Util.exibirValorMonetarioBr(faturaModal.valorComissaoSemNfe)}</b>
                                </span>
                              )}
                              {faturaModal.tipoComissao !== "comissao_compra_boleto" && (
                                <span style={{ opacity: ".45" }}>
                                  <b>Comissão compra/boleto: &nbsp; {Util.exibirValorMonetarioBr(faturaModal.valorComissaoCompraBoleto)}</b>
                                </span>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                      <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}></div>
                    </div>
                  </Card.Content>
                  <Card.Content style={{ paddingBottom: ".6rem", paddingTop: ".4rem" }}>
                    {faturaModal.aprovacaoComercial === true && (
                      <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "2rem" }}>
                        <span style={{ width: "35%" }}>
                          Aprovada no Comercial: &nbsp;<b>{faturaModal.responsavelAprovacaoComercial}</b>
                        </span>
                        <span>
                          Data da Aprovação: &nbsp;<b>{Util.exibirDataFormatada(faturaModal.dataAprovacaoComercial)}</b>
                        </span>
                      </div>
                    )}
                    {faturaModal.aprovacaoFinanceiro === true && (
                      <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "2rem" }}>
                        <span style={{ width: "35%" }}>
                          Aprovada no Financeiro: &nbsp;<b>{faturaModal.responsavelAprovacaoFinanceiro}</b>
                        </span>
                        <span>
                          Data da Aprovação: &nbsp;<b>{Util.exibirDataFormatada(faturaModal.dataAprovacaoFinanceiro)}</b>
                        </span>
                      </div>
                    )}
                  </Card.Content>
                </Card>
              </Segment>
            </Dimmer.Dimmable>
          </Modal.Content>
        )}
      </Modal>
    </div>
  );
}
